import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router';
const routes: Array<RouteRecordRaw> = [
    // 项目打开后进入的默认地址
    {
        path: '/login',
        name: 'Login',
        meta: {
            title: '登录',
            tabLabel: '登录',
            keepAlive: true,
            requireAuth: false
        },
        component: () => import('@/views/login/index.vue')
    },
    {
        path: '/',
        name: 'Index',
        meta: {
            title: '首页',
            tabLabel: '首页',
            keepAlive: true,
            requireAuth: true
        },
        component: () => import('@/views/home/home.vue')
    },
    // {
    //     path: '/',
    //     redirect: '/home'
    // },
    {
        path: '/home',
        component: () => import('../views/home/home.vue')
    },
    {
        path: '/login',
        component: () => import('../views/login/index.vue')
    },
    {
        path: '/marketSituation',
        meta: {
            title: '看行情',
            requireAuth: false
        },
        component: () => import('../views/market/index.vue')
    },
    {
        path: '/presaleList',
        meta: {
            title: '最新预售',
            requireAuth: false
        },
        component: () => import('../views/business/presaleList.vue')
    },
    {
        path: '/presale/:id',
        meta: {
            title: '预售详情',
            requireAuth: false
        },
        component: () => import('../views/business/presale.vue')
    },
    {
        path: '/infoList',
        meta: {
            title: '最新资讯',
            requireAuth: false
        },
        component: () => import('../views/article/infoList.vue')
    },
    {
        path: '/info/:id',
        meta: {
            title: '资讯详情',
            requireAuth: false
        },
        component: () => import('../views/article/infoDetail.vue')
    },
    {
        path: '/policy/:id',
        meta: {
            title: '政策详情',
            requireAuth: false
        },
        component: () => import('../views/article/policyDetail.vue')
    },
    {
        path: '/biddingHall',
        meta: {
            title: '竞价大厅',
            requireAuth: false
        },
        component: () => import('../views/biddingHall/index.vue')
    },
    {
        path: '/policyList',
        meta: {
            title: '政策补贴',
            requireAuth: false
        },
        component: () => import('../views/article/policyList.vue')
    },
    {
        path: '/technologyClass',
        meta: {
            title: '技术课堂',
            requireAuth: false
        },
        component: () => import('../views/technologyClass/index.vue')
    },
    {
        path: '/search',
        meta: {
            title: '搜素',
            requireAuth: false
        },
        component: () => import('../views/business/search.vue')
    },
]
const router = createRouter({
    history: createWebHistory(), //去除URL中的#号
    routes
})

router.beforeEach(async (to, _from, next) => {
    // 页面路由跳转前，动态设置页面标题，请提前在meta里定义页面标题
    document.title = to.meta.headerMenuLabel || to.meta.title || to.meta.tabLabel || ''
    // 检查是否有该页面的访问权限
    next()
})

router.afterEach(() => {
    // 单页应用手动采集页面信息
})

export default router
